// extracted by mini-css-extract-plugin
export default {"loadingDecorator":"FormDecorator_loadingDecorator__9iTJz","loading":"FormDecorator_loading__G8Aj2","decorator":"FormDecorator_decorator__PNnnk"};